import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const activateUser = (id) => {
  return axios.get(API + "helper/send-activation-email/"+id+"/",{headers: authHeader(),});
};

const verifyUser = (uidb64,token) => {
  return axios.get(API + "helper/verify-activation-email/"+uidb64+"/"+token+"/",{headers: authHeader(),});
};


const changePassword = (uuid,password) => {
  return axios.post(API + "helper/changePassword/",{
    uuid,
    password,
  },
  {headers: authHeader(),});
};


const verifyUserEmail = (email) => {
  return axios.get(API + "helper/verify-forgot-password/"+email+"/",{headers: authHeader(),});
};

const ForgotPassword = (email,password) => {
  return axios.post(API + "helper/changeforgotpassword/",{
    email,
    password,
  },
  {headers: authHeader(),});
};

const ActivateUserService = {
    activateUser,
    verifyUser,
    changePassword,
    verifyUserEmail,
    ForgotPassword
  };
  export default ActivateUserService;